"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class MispController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            get: '/v1/admin/config/misp',
            test: '/v1/admin/config/misp/test',
            export: '/connector/misp/export/:caseId/:server',
            import: '/v1/connector/misp/case/import',
            getStatus: '/connector/misp/status',
        };
    }
    list() {
        throw new Error("Can't list misp");
    }
    count() {
        throw new Error("Can't count misp");
    }
    create({}) {
        throw new Error("Can't create misp!");
    }
    // eslint-disable-next-line
    edit(data) {
        return this.manager.put({ url: this.endpoints.get }, data);
    }
    delete() {
        throw new Error("Can't delete misp!");
    }
    getConfig() {
        return this.manager.get({
            url: this.endpoints.get,
        });
    }
    getStatus() {
        return this.manager.get({
            url: this.endpoints.getStatus,
        });
    }
    test(data) {
        return this.manager.post({
            url: this.endpoints.test,
        }, data);
    }
    import(data) {
        return this.manager.post({
            url: this.endpoints.import,
        }, data);
    }
    export(data) {
        const { caseId, server } = data;
        return this.manager.post({
            url: this.endpoints.export,
            params: {
                caseId,
                server,
            },
        });
    }
}
exports.default = MispController;
